import React from "react";
import Slider from "react-slick";
import { FaStar } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const testimonials = [
  {
    name: "Sarah T.",
    location: "Mumbai, India",
    review:
      "From the moment we arrived, the service was outstanding. The room was beyond our expectations, and the views were breathtaking!",
    rating: 5,
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Raj K.",
    location: "Delhi, India",
    review:
      "Amazing hotel and excellent customer service. The whole experience was flawless!",
    rating: 4,
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Anjali P.",
    location: "Bangalore, India",
    review:
      "Loved the ambience and food. Booking was seamless and the stay was so peaceful!",
    rating: 5,
    avatar: "https://randomuser.me/api/portraits/women/65.jpg",
  },
];

const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -right-5 top-1/2 z-20 -translate-y-1/2 rounded-full bg-[#fff] p-2 text-white shadow shadow-gray-800 hover:bg-gray-600 md:-right-2"
  >
    <IoIosArrowForward color="black" size={22} />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -left-5 top-1/2 z-20 -translate-y-1/2 rounded-full bg-[#fff] p-2 text-white shadow shadow-gray-800 hover:bg-gray-600 md:-left-2"
  >
    <IoIosArrowBack color="black" size={22} />
  </button>
);

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="mx-auto max-w-screen-2xl px-4 py-12 text-center">
      <h2 className="mb-2 text-2xl font-bold sm:text-3xl">
        <span className="text-[#FF9F29]">● </span>
        Trusted by Travelers: Remarkable Stays, Real Reviews
      </h2>
      <p className="mb-10 text-sm text-gray-600 sm:text-base">
        Discover what our happy guests have to say about the comfort, luxury,
        and effortless booking they enjoyed with Makku.
      </p>

      <div className="relative">
        <Slider {...settings}>
          {testimonials.map((t, i) => (
            <div key={i} className="px-3">
              <div className="mx-auto min-h-[280px] rounded-2xl bg-[#2A2F8D] px-6 py-8 text-white shadow-lg">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="mx-auto mb-4 h-16 w-16 rounded-full border-2 border-white object-cover"
                />
                <p className="mb-4 text-sm italic sm:text-base">“{t.review}”</p>
                <h4 className="text-base font-semibold sm:text-lg">{t.name}</h4>
                <p className="mb-3 text-xs text-gray-300 sm:text-sm">
                  {t.location}
                </p>
                <div className="flex justify-center gap-1">
                  {Array.from({ length: 5 }, (_, idx) => (
                    <FaStar
                      key={idx}
                      className={`text-sm ${
                        idx < t.rating ? "text-yellow-400" : "text-gray-400"
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonial;
